/**
 * User role constants and types
 * Centralized role definitions to eliminate magic strings
 */

export const userRoles = {
  admin: 'admin',
  quality: 'quality',
  normal: 'normal',
  basic: 'basic',
} as const;

export type UserRole = (typeof userRoles)[keyof typeof userRoles];

export const allRoles = Object.values(userRoles);

/**
 * User status constants
 */
export const userStatuses = {
  active: 'active',
  disabled: 'disabled',
} as const;

export type UserStatus = (typeof userStatuses)[keyof typeof userStatuses];

export const allStatuses = Object.values(userStatuses);

/**
 * Role display labels for UI
 */
export const roleLabels: Record<UserRole, string> = {
  [userRoles.admin]: 'Admin',
  [userRoles.quality]: 'Quality',
  [userRoles.normal]: 'Normal',
  [userRoles.basic]: 'Basic',
};

/**
 * Role option type for dropdowns
 */
export type RoleOption = {
  value: string;
  label: string;
};

/**
 * Role options for dropdowns and forms
 */
export const roleOptions: RoleOption[] = [
  {value: '', label: 'Select a role'},
  {value: userRoles.admin, label: roleLabels[userRoles.admin]},
  {value: userRoles.quality, label: roleLabels[userRoles.quality]},
  {value: userRoles.normal, label: roleLabels[userRoles.normal]},
  {value: userRoles.basic, label: roleLabels[userRoles.basic]},
];
